import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { Message } from '../../shared/index';
import { MassCommService } from '../../shared/mass-comm.service';
import { HtmlTemplateService } from '../../../templates/shared/html-template.service';
import { HtmlTemplate } from '../../../templates/shared/html-template.model';
import { NameValue } from '../../../shared/model/name-value.model';
import { SelectItem } from 'primeng/api';
import { MassCommMessageHtmlEditorDialogComponent } from './mass-comm-message-html-editor-dialog/mass-comm-message-html-editor-dialog.component';
import { PrettifyHtmlPipe } from '../../../shared/pipes/prettify-html.pipe';
import { ModularWlWysiwygEditorComponent } from '../../../shared/widgets/modular-wysiwyg-editor/modular-wysiwyg-editor.component';

/**
 * edit a single mass comm message
 */
@Component({
  selector: 'wl-mass-comm-message-edit-message',
  templateUrl: 'mass-comm-message-edit-message.component.html',
  styleUrls: [],
  providers: [PrettifyHtmlPipe],
    standalone: false
})
export class MassCommMessageEditMessageComponent implements OnInit {
  @ViewChild(MassCommMessageHtmlEditorDialogComponent) private _htmlDialog: MassCommMessageHtmlEditorDialogComponent;
  @ViewChild(ModularWlWysiwygEditorComponent) private _wysiwygEditor: ModularWlWysiwygEditorComponent;

  public userAccessLevel: number = 0;
  @Input() public message: Message = null;
  @Input() public readonly: boolean = false;
  @Input() public isResend: boolean = false;
  @Input() public isScheduled: boolean = false;

  @Output() public validChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public htmlTemplates: Array<HtmlTemplate> = [];
  public selectedHtmlTemplateId: number = 0;
  public selectedHtmlTemplate: HtmlTemplate = {} as HtmlTemplate;

  public specialFields: Array<SelectItem> = [];

  public showModal = false;
  public loading = false;

  /**
   * inject
   */
  public constructor(
    private _massCommService: MassCommService,
    private _htmlTemplateService: HtmlTemplateService,
    private _prettifyHtmlPipe: PrettifyHtmlPipe,
  ) {}

  /**
   * my initer
   */
  public ngOnInit(): void {
    this.loading = true;

    Promise.all([
      this._htmlTemplateService.getHtmlTemplates().then((templates: Array<HtmlTemplate>) => {
        if (templates) this.htmlTemplates = templates;
      }),

      this._massCommService.getEmailSpecialFields().then((specialFields) => {
        if (specialFields) {
          this.specialFields = specialFields.map<SelectItem>((field) => {
            return { label: field.name, value: field.value };
          });
        }
      }),
    ]).then(
      () => (this.loading = false),
      () => (this.loading = false)
    );
  }

  /**
   * called when the validity of this form is changed
   * @param newValidity
   */
  public handleFormValidChanged(newValidity: boolean) {
    this.validChange.emit(newValidity);
  }

  /**
   * when the user selects an html template from the dropdown
   */
  public handleHtmlTemplateSelected(): void {
    this.selectedHtmlTemplate = this.htmlTemplates.find((x) => x.ID == this.selectedHtmlTemplateId);
    if (this.message.Message) {
      this.showModal = true;
    } else {
      this.message.Message = this.selectedHtmlTemplate.HTML;
      if (this.selectedHtmlTemplate.Subject) {
        this.message.Subject = this.selectedHtmlTemplate.Subject;
      }
      if (this.selectedHtmlTemplate.FromEmail) {
        this.message.SendFrom = this.selectedHtmlTemplate.FromEmail;
      }
    }
  }

  /**
   * when the user wants to replace the message with the selected html template
   */
  public handleConfirmHtmlTemplateReplaceClick(): void {
    this.message.Message = this.selectedHtmlTemplate.HTML;
    if (this.selectedHtmlTemplate.Subject) {
      this.message.Subject = this.selectedHtmlTemplate.Subject;
    }
    if (this.selectedHtmlTemplate.FromEmail) {
      this.message.SendFrom = this.selectedHtmlTemplate.FromEmail;
    }
    this.showModal = false;
  }

  /**
   * when the user wants to append the selected html template to the message
   */
  public handleConfirmHtmlTemplateAppendClick(): void {
    this.message.Message += this.selectedHtmlTemplate.HTML;
    if (this.selectedHtmlTemplate.Subject) {
      this.message.Subject = this.selectedHtmlTemplate.Subject;
    }
    if (this.selectedHtmlTemplate.FromEmail) {
      this.message.SendFrom = this.selectedHtmlTemplate.FromEmail;
    }
    this.showModal = false;
  }

  /**
   * writes the editor's inlined-style HTML into message.Message; await before saving or sending
   */
  public flushEditor(): Promise<void> {
    return this._wysiwygEditor?.flushInlineStyles() ?? Promise.resolve();
  }

  public openHtmlDialog() {
    this._htmlDialog.open(this.message.Text);
  }

  public toggleMessageText() {
    if (this.message.Text == null) {
      this.message.Text = false;
    }
    if (!this.message.Text && this.message.Message) {
      this.message.Message = this._prettifyHtmlPipe.transform(this.message.Message);
    }
    this.message.Text = !this.message.Text;
  }
}
